/**
 * A `ConversationsTarget` → the corpus rows behind it, filtered exactly as the
 * prototype's modal was handed them, so a list reconciles with what was clicked.
 */
import type { ConversationsTarget, DashboardQuery } from '@/data-sources/contract';

import { drillResolvers } from '../drill';
import type { MentionRow } from '../engine/generator';
import { scoped } from '../query';

export class UnresolvableTargetError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'UnresolvableTargetError';
  }
}

export function rowsOfTarget(
  target: ConversationsTarget,
  query: DashboardQuery,
): readonly MentionRow[] {
  switch (target.kind) {
    case 'point': {
      const resolve = drillResolvers[target.drill.widget];
      if (!resolve) {
        throw new UnresolvableTargetError(`No drill resolver for widget "${target.drill.widget}".`);
      }
      return resolve(target.drill, query);
    }
    case 'page':
      /* `PageConversationsModal`: one brand on one channel (or every channel) of the chip-filtered category rows. */
      return scoped(query).category.filter(
        (row) =>
          row.brand === target.brand &&
          (target.channel === undefined || row.channel === target.channel),
      );
    case 'community':
      /* `CommunityConversationsModal`: the same field the ranking grouped on, over the same own-brand rows. */
      return scoped(query).own.filter((row) => row[target.dimension] === target.value);
  }
}
